import { requestBase, requestMain } from '@/apis/index';

export function getWalletInfo() {
  return requestMain('', {
    method: 'get',
    params: {
      _m: 'home_page_wallet',
    },
    data: {},
  });
}

// 进行中的订单
export function getTodoList(pageNo: number) {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'order',
      _a: 'todo_list',
    },
    data: {
      pageSize: 20,
      pageNo,
    },
  });
}
// export function getLaunchContent(data: any) {
//   const params = {
//     businessType: '303',
//     ...data,
//   };
//   return requestMain('', {
//     method: 'post',
//     params: {
//       _m: 'launch_content',
//     },
//     data: params,
//   });
// }

export function getMonthStatistics() {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'order',
      _a: 'current_month_statistics',
    },
    data: {},
  });
}

export function getBanner(data: any) {
  return requestMain('', {
    method: 'post',
    params: {
      _m: 'launch_content',
    },
    data: {
      businessType: '303',
      ...data,
    },
  });
}

export function getWaitInvoiceFee(data: any) {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'bill',
        _a: 'can_invoice',
      },
      data,
    },
    true
  );
}

// 获取零担是否开城
interface QueryIsOpenLingDanData {
  city_name: string;
}
export const queryIsOpenLingDan = (data: QueryIsOpenLingDanData) => {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'user_get_product_services',
      },
      data,
    },
    true
  );
};

// 公告和资源位
export const getAuthGuide = (cityId?: number) => {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'auth_guide',
      },
      data: {
        businessTypeGuide: 312,
        businessTypeResources: 314,
        city_id: cityId,
      },
    },
    true
  );
};

// 是否显示认证模块
export const getAuthJudge = () => {
  return requestMain(
    '',
    {
      method: 'post',
      params: {
        _m: 'auth_judge',
      },
    },
    true
  );
};
// 获取首页下单入口模块角标
export function getHomeCornerTag(city_id: number) {
  return requestMain('', {
    method: 'post',
    params: {
      _a: 'config',
      _m: 'home',
    },
    data: {
      business_type: 315, // pc 315 app 310 固定传值
      city_id,
    },
  });
}

// 账期申请进度
export function getFinanceAccountApplicationProgress() {
  return requestMain('', {
    showError: false,
    method: 'post',
    params: {
      _m: 'finance_account_get_application_progress',
    },
  });
}

// 账期申请前置条件检查
export function checkAccountApplyCondition() {
  return requestBase('/eucSoa/ep/checkAccountApplyCondition');
}
